// import store from '../store'
export const entityType = {
	center: 0,
	doctor: 1,
	pharmacy: 2,
}

export const dailyReportClassification = {
	important: 0,
	complaint: 1,
	normalNote: 2,
}

export const paymentMethod = {
	cash: 1,
	credit: 2,
	debit: 3,
}

// Permission IDs from /users/getself
export const visitPermission = {
	marketing: 34,
	scientific: 35,
}

// rolePermissions values
export const rolePermission = {
	undefined: 0,
	read: 1,
	action: 2,
}

export const sectionType = {
	staff: 1,
	customers: 2,
	materials: 3,
	visits: 4
	// customerTypeOne: store.state.configurations.customersTypesConf ? store.state.configurations.customersTypesConf.length : null
}

export const loyalty = [
	{
		id: 0,
		name: 'High'
	},
	{
		id: 1,
		name: 'Moderate'
	},
	{
		id: 2,
		name: 'Low'
	}
]

export const religions = [
	{
		id: 0,
		name: 'Muslim'
	},
	{
		id: 1,
		name: 'Christian'
	},
	{
		id: 2,
		name: 'Armenian'
	},
	{
		id: 3,
		name: 'Other'
	}
]

export const personalityArray = [
	{
		id: 0,
		name: 'C' 
	},
	{
		id: 1,
		name: 'D' 
	},
	{
		id: 2,
		name: 'I'
	},
	{
		id: 3,
		name: 'S'
	},
	{
		id: 4,
		name: 'Other'
	}
]